import { render, staticRenderFns } from "./TabCRM.vue?vue&type=template&id=7a069da6&scoped=true"
import script from "./TabCRM.vue?vue&type=script&lang=ts"
export * from "./TabCRM.vue?vue&type=script&lang=ts"
import style0 from "./TabCRM.vue?vue&type=style&index=0&id=7a069da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a069da6",
  null
  
)

export default component.exports